/**
 * Dicionário PT → ES (Español).
 * As strings em Português do app são as CHAVES; o valor é a tradução em espanhol.
 * Quando lang === "pt", o t() retorna a própria chave (sem lookup).
 * Chaves ausentes caem no fallback (texto PT original).
 */
export const ES = {
  // ── Navegação / AdminLayout ────────────────────────────────────────────
  "Resumo do dia": "Resumen del día",
  "Agenda": "Agenda",
  "Liberação da agenda": "Liberación de agenda",
  "Cadastros": "Registros",
  "Clientes": "Clientes",
  "Solicitações": "Solicitudes",
  "Equipe": "Equipo",
  "Colaboradores": "Colaboradores",
  "Equipes": "Equipos",
  "Cargos": "Cargos",
  "Estoque": "Inventario",
  "Equipamentos": "Equipos",
  "Itens de limpeza": "Insumos de limpieza",
  "Financeiro": "Finanzas",
  "Pagamentos": "Pagos",
  "Recebimentos": "Cobranzas",
  "Relatórios financeiros": "Reportes financieros",
  "Histórico de pagamentos": "Historial de pagos",
  "Relatórios gerais": "Reportes generales",
  "Histórico": "Historial",
  "Pessoal": "Personal",
  "Minhas notas": "Mis notas",
  "Comunicação": "Comunicación",
  "Notificações": "Notificaciones",
  "Templates de mensagem": "Plantillas de mensaje",
  "Histórico de envios": "Historial de envíos",
  "Configurações": "Configuración",
  "Dados da Empresa": "Datos de la empresa",
  "Cores": "Colores",
  "Editar perfil →": "Editar perfil →",
  "Instalar app": "Instalar app",
  "Sair": "Salir",
  "Fechar menu": "Cerrar menú",
  "Abrir menu": "Abrir menú",
  "Relatórios": "Reportes",
  "itens requerendo atenção": "elementos que requieren atención",

  // ── Status / Papéis ────────────────────────────────────────────────────
  "Agendada": "Programada",
  "Em deslocamento": "En camino",
  "Em andamento": "En progreso",
  "Finalizada": "Finalizada",
  "Cancelada": "Cancelada",
  "Atrasada": "Atrasada",
  "Dia concluído": "Día completado",
  "Horário inválido": "Horario inválido",
  "Administrador": "Administrador",
  "Supervisão": "Supervisión",
  "Colaborador": "Colaborador",
  "URGENTE": "URGENTE",
  "MÉDIA": "MEDIA",
  "BAIXA": "BAJA",

  // ── Comuns ─────────────────────────────────────────────────────────────
  "Carregando…": "Cargando…",
  "Voltar": "Volver",
  "Hoje": "Hoy",
  "Amanhã": "Mañana",
  "Ontem": "Ayer",
  "Editar": "Editar",
  "Abrir": "Abrir",
  "Atualizar": "Actualizar",
  "opcional": "opcional",
  "Falha": "Error",

  // ── Login ──────────────────────────────────────────────────────────────
  "Operações de limpeza": "Operaciones de limpieza",
  "Bem-vindo de volta": "Bienvenido de nuevo",
  "Entre no seu painel.": "Ingresa a tu panel.",
  "Acesse sua conta para gerenciar equipes, agenda e financeiro — ou iniciar sua próxima limpeza com geofence em tempo real.":
    "Accede a tu cuenta para gestionar equipos, agenda y finanzas — o inicia tu próxima limpieza con geocerca en tiempo real.",
  "Painel administrativo:": "Panel administrativo:",
  "agenda, clientes, equipes, financeiro e relatórios.": "agenda, clientes, equipos, finanzas y reportes.",
  "App de campo:": "App de campo:",
  "suas limpezas do dia, check-in com GPS, fotos antes/depois.": "tus limpiezas del día, check-in con GPS, fotos antes/después.",
  "E-mail": "Correo",
  "Senha": "Contraseña",
  "Esqueci minha senha": "Olvidé mi contraseña",
  "Ocultar senha": "Ocultar contraseña",
  "Mostrar senha": "Mostrar contraseña",
  "Esqueceu a senha? Recupere por e-mail em 1 minuto.": "¿Olvidaste tu contraseña? Recupérala por correo en 1 minuto.",
  "Recuperar agora →": "Recuperar ahora →",
  "Entrando…": "Ingresando…",
  "Entrar": "Ingresar",
  "ou": "o",
  "Entrar com Google": "Ingresar con Google",
  "Ainda não tem conta?": "¿Aún no tienes cuenta?",
  "Criar empresa grátis →": "Crear tu empresa gratis →",
  "Login seguro": "Inicio seguro",
  "Agenda ao vivo": "Agenda en vivo",
  "Sua operação de limpeza,": "Tu operación de limpieza,",
  "organizada e no controle.": "organizada y bajo control.",
  "Agenda, equipes, GPS, fotos antes/depois e relatórios — em um único painel pensado para celular e desktop.":
    "Agenda, equipos, GPS, fotos antes/después y reportes — en un solo panel pensado para móvil y escritorio.",
  "Raio de geofence": "Radio de geocerca",
  "Funciona offline": "Funciona sin conexión",
  "Acesso em campo": "Acceso en campo",
  "Sistema operacional · v2026": "Sistema operativo · v2026",
  "Limpeza profissional": "Limpieza profesional",
  "Banheiro brilhando": "Baño reluciente",
  "Ambiente arejado": "Ambiente ventilado",
  "Pronto para o cliente": "Listo para el cliente",
  "E-mail ou senha inválidos": "Correo o contraseña inválidos",
  'Esta conta é de colaborador. Use a aba "Colaborador" para acessar o app de campo.':
    'Esta cuenta es de colaborador. Usa la pestaña "Colaborador" para acceder a la app de campo.',
  'Esta conta é administrativa. Use a aba "Admin / Supervisor" para acessar o painel.':
    'Esta cuenta es administrativa. Usa la pestaña "Admin / Supervisor" para acceder al panel.',
  "Bem-vindo(a), {name}": "Bienvenido(a), {name}",

  // ── Dashboard ──────────────────────────────────────────────────────────
  "Painel operacional": "Panel operativo",
  "Limpezas hoje": "Limpiezas hoy",
  "Finalizadas": "Finalizadas",
  "Equipes ativas": "Equipos activos",
  "Faturamento hoje": "Ingresos hoy",
  "cliente em atraso": "cliente atrasado",
  "clientes em atraso": "clientes atrasados",
  "a receber": "por cobrar",
  "Ver detalhes →": "Ver detalles →",
  "suprimento no/abaixo do estoque mínimo": "insumo en/por debajo del stock mínimo",
  "suprimentos no/abaixo do estoque mínimo": "insumos en/por debajo del stock mínimo",
  "Repor →": "Reponer →",
  "Mapa das casas registradas": "Mapa de casas registradas",
  "clientes": "clientes",
  "Abrir mapa completo →": "Abrir mapa completo →",
  "Nenhum cliente com GPS capturado ainda.": "Aún no hay clientes con GPS capturado.",
  "Equipes finalizadas hoje": "Equipos finalizados hoy",
  "Ver todas →": "Ver todas →",
  "Nenhuma equipe cadastrada.": "No hay equipos registrados.",
  "Nenhuma equipe com casas atribuídas para hoje.": "No hay equipos con casas asignadas para hoy.",
  "✓ Concluído": "✓ Completado",
  "casas finalizadas": "casas finalizadas",
  "Em campo": "En campo",
  "casas": "casas",
  "Limpezas de hoje": "Limpiezas de hoy",
  "Ver agenda completa →": "Ver agenda completa →",
  "Nenhuma limpeza agendada para hoje.": "No hay limpiezas programadas para hoy.",
  "Horário": "Horario",
  "Cliente": "Cliente",
  "Ação": "Acción",
  "contrato": "contrato",
  "contratos": "contratos",
  "vencido(s) ou": "vencido(s) o",
  "expirando em 30 dias": "venciendo en 30 días",
  "Receita recorrente em risco:": "Ingreso recurrente en riesgo:",
  "/limpeza": "/limpieza",
  "Vencido há {n}d": "Vencido hace {n}d",
  "Vence hoje": "Vence hoy",
  "{n}d restantes": "{n}d restantes",
  "Ver todos ({n}) →": "Ver todos ({n}) →",

  // ── Widgets do Dashboard ───────────────────────────────────────────────
  "Saúde da operação": "Salud de la operación",
  "Snapshot ao vivo · {pct}% concluído hoje": "Vista en vivo · {pct}% completado hoy",
  "atualiza a cada 30s": "se actualiza cada 30s",
  "Atrasados": "Atrasados",
  "Em 30min": "En 30min",
  "Concluídos": "Completados",
  "Operadores ativos": "Operadores activos",
  "Atrasados agora ({n})": "Atrasados ahora ({n})",
  "{n}min atrasado": "{n}min de atraso",
  "Próximos 30 min ({n})": "Próximos 30 min ({n})",
  "em {n}min": "en {n}min",
  "Tendência financeira · últimos 30 dias": "Tendencia financiera · últimos 30 días",
  "Tendência financeira · últimos {n} meses": "Tendencia financiera · últimos {n} meses",
  "em {m}": "en {m}",
  "vs mês anterior": "vs mes anterior",
  "30 dias": "30 días",
  "Receita": "Ingresos",
  "Custos": "Costos",
  "Lucro": "Ganancia",

  // ── Mobile (colaborador) ───────────────────────────────────────────────
  "Olá,": "Hola,",
  "Modo Foco — só o trabalho atual": "Modo Enfoque — solo el trabajo actual",
  "Sua agenda será liberada às {time}": "Tu agenda se liberará a las {time}",
  "Aguarde o horário de liberação. Quando chegar, suas casas aparecem aqui automaticamente.":
    "Espera la hora de liberación. Cuando llegue, tus casas aparecerán aquí automáticamente.",
  "Esta semana": "Esta semana",
  "Próximas casas": "Próximas casas",
  "Avaliação grátis: {n} dias restantes": "Prueba gratis: {n} días restantes",
  "Sua avaliação gratuita expirou": "Tu prueba gratuita ha expirado",
  "Último dia da sua avaliação gratuita": "Último día de tu prueba gratuita",
  "Assine agora para reativar o acesso completo.": "Suscríbete ahora para reactivar el acceso completo.",
  "Assine um plano para continuar sem interrupções.": "Suscríbete a un plan para continuar sin interrupciones.",
  "Assinar": "Suscribirse",
  "feitas": "hechas",
  "Você não tem limpezas esta semana.": "No tienes limpiezas esta semana.",
  "Observações": "Notas",
  "← deslize para WhatsApp · deslize para mapa →": "← desliza para WhatsApp · desliza para el mapa →",
  "deslize para mapa →": "desliza para el mapa →",
  "Trabalho iniciado": "Trabajo iniciado",
  "Falha ao iniciar": "Error al iniciar",
  "GPS indisponível neste dispositivo": "GPS no disponible en este dispositivo",
  "Não foi possível obter sua localização": "No se pudo obtener tu ubicación",
  "Próximo trabalho": "Próximo trabajo",
  "Quando chegar no local, toque em 'Cheguei na casa'": "Cuando llegues al lugar, toca 'Llegué a la casa'",
  "Toque em 'Cheguei na casa' assim que estacionar": "Toca 'Llegué a la casa' apenas estaciones",
  "Limpeza em andamento": "Limpieza en progreso",
  "Em andamento desde {time}": "En progreso desde las {time}",
  "Validando GPS…": "Validando GPS…",
  "Cheguei na casa": "Llegué a la casa",
  "Concluí a limpeza": "Terminé la limpieza",
  "Ver detalhes": "Ver detalles",
  "Traçar rota": "Trazar ruta",

  // ── Kiosk (Modo Foco) ──────────────────────────────────────────────────
  "Sair do modo Foco": "Salir del modo Enfoque",
  "Foco": "Enfoque",
  "Tudo certo!": "¡Todo listo!",
  "Você não tem nenhuma limpeza pendente no momento.": "No tienes ninguna limpieza pendiente en este momento.",
  "● Em andamento": "● En progreso",
  "Tocar para abrir no Google Maps →": "Toca para abrir en Google Maps →",
  "🔑 Código da porta": "🔑 Código de la puerta",
  "CHEGUEI NA CASA": "LLEGUÉ A LA CASA",
  "FINALIZAR LIMPEZA": "FINALIZAR LIMPIEZA",
  "Abrir rota no mapa": "Abrir ruta en el mapa",
  "Falha ao carregar trabalho": "Error al cargar el trabajo",

  // ── Job Detail ─────────────────────────────────────────────────────────
  "Limpeza": "Limpieza",
  "Descrição": "Descripción",
  "Contato": "Contacto",
  "Abrir no Google Maps": "Abrir en Google Maps",
  "Equipe:": "Equipo:",
  "Idioma falado pelo cliente": "Idioma hablado por el cliente",
  "Código da porta": "Código de la puerta",
  "Observações importantes": "Notas importantes",
  "Você precisa estar a até 200m do endereço para iniciar.": "Debes estar a menos de 200m de la dirección para iniciar.",
  "Iniciada em": "Iniciada a las",
  "FINALIZAR": "FINALIZAR",
  "Reverter status para Agendada (admin)": "Revertir estado a Programada (admin)",
  "↩ Voltar para agendada (admin)": "↩ Volver a programada (admin)",
  "Finalizada em": "Finalizada a las",
  "Duração": "Duración",
  "Limpeza encerrada": "Limpieza cerrada",
  "Baixar comprovante PDF": "Descargar comprobante PDF",
  "Gerando comprovante…": "Generando comprobante…",
  "Comprovante baixado": "Comprobante descargado",
  "Erro ao gerar PDF": "Error al generar el PDF",
  "AGENDADA": "PROGRAMADA",
  "DESLOCAMENTO": "EN CAMINO",
  "ANDAMENTO": "EN PROGRESO",
  "CANCELADA": "CANCELADA",
  "📝 Checklist de limpeza": "📝 Lista de limpieza",
  "concluídos": "completados",
  "Toque em um item para marcar como concluído. Será salvo ao finalizar a limpeza.":
    "Toca un elemento para marcarlo como completado. Se guardará al finalizar la limpieza.",
  "Fotos do serviço": "Fotos del servicio",
  "Antes": "Antes",
  "Depois": "Después",
  "Assinatura do cliente": "Firma del cliente",
  "Assinatura capturada": "Firma capturada",
  "Peça ao cliente para assinar abaixo (ou pule este passo — será salva automaticamente ao finalizar se houver desenho).":
    "Pide al cliente que firme abajo (o salta este paso — se guardará automáticamente al finalizar si hay un dibujo).",
  "Localização": "Ubicación",
  "Contato do cliente": "Contacto del cliente",
  "Resumo financeiro": "Resumen financiero",
  "Valor da limpeza": "Valor de la limpieza",
  "Frequência": "Frecuencia",
  "Tipo": "Tipo",
  "membro(s)": "miembro(s)",
  "GPS indisponível": "GPS no disponible",
  "Limpeza iniciada": "Limpieza iniciada",
  "Limpeza finalizada": "Limpieza finalizada",
  "↻ Próxima limpeza agendada automaticamente para {date}": "↻ Próxima limpieza programada automáticamente para {date}",
  "Voltar este atendimento para 'Agendada'? Os dados de START (hora e GPS) serão apagados.":
    "¿Revertir este servicio a 'Programada'? Los datos de INICIO (hora y GPS) se borrarán.",
  "Atendimento revertido para agendada": "Servicio revertido a programada",

  // ── Histórico ──────────────────────────────────────────────────────────
  "Meu trabalho": "Mi trabajo",
  "Histórico de limpezas": "Historial de limpiezas",
  "Todas as casas que você já finalizou": "Todas las casas que has finalizado",
  "Buscar casa ou endereço": "Buscar casa o dirección",
  "Casas atendidas": "Casas atendidas",
  "Tempo total": "Tiempo total",
  "Estimado a receber": "Estimado a recibir",
  "Nenhuma limpeza finalizada ainda.": "Aún no hay limpiezas finalizadas.",
  "Data": "Fecha",
  "Início": "Inicio",
  "Fim": "Fin",
  "Valor": "Valor",
  "Minhas limpezas": "Mis limpiezas",
  "Tudo o que você já finalizou": "Todo lo que has finalizado",

  // ── Agenda / Schedule ──────────────────────────────────────────────────
  "Janeiro": "Enero",
  "Fevereiro": "Febrero",
  "Março": "Marzo",
  "Abril": "Abril",
  "Maio": "Mayo",
  "Junho": "Junio",
  "Julho": "Julio",
  "Agosto": "Agosto",
  "Setembro": "Septiembre",
  "Outubro": "Octubre",
  "Novembro": "Noviembre",
  "Dezembro": "Diciembre",
  "Dom": "Dom",
  "Seg": "Lun",
  "Ter": "Mar",
  "Qua": "Mié",
  "Qui": "Jue",
  "Sex": "Vie",
  "Sáb": "Sáb",
  "Operação": "Operación",
  "Dia": "Día",
  "Semana": "Semana",
  "Mês": "Mes",
  "Agendar": "Agendar",
  "Buscar por cliente, equipe, colaborador…": "Buscar por cliente, equipo, colaborador…",
  "Crie pelo menos uma equipe antes de agendar": "Crea al menos un equipo antes de agendar",
  "Agendado:": "Agendado:",
  "Falha ao agendar": "Error al agendar",
  "Movido para": "Movido a",
  "Falha ao mover": "Error al mover",
  "+{n} mais": "+{n} más",
  "Sem equipe": "Sin equipo",
  "atendimento(s)": "servicio(s)",
  "Sem limpezas.": "Sin limpiezas.",
  "arraste para mover": "arrastra para mover",
  "Selecione cliente e equipe": "Selecciona un cliente y un equipo",
  "Informe a data e o horário do agendamento": "Indica la fecha y la hora del agendamiento",
  "Data/hora inválida": "Fecha/hora inválida",
  "Informe um horário válido (00:00 não é permitido)": "Indica un horario válido (00:00 no está permitido)",
  "Limpeza agendada": "Limpieza agendada",
  "Agendar limpeza": "Agendar limpieza",
  "Data e Hora": "Fecha y hora",
  "Prioridade": "Prioridad",
  "Opcional — destaca no app do colaborador": "Opcional — se destaca en la app del colaborador",
  "— selecionar —": "— seleccionar —",
  "— Automática (por urgência) —": "— Automática (por urgencia) —",
  "🔴 Urgente": "🔴 Urgente",
  "🟢 Média": "🟢 Media",
  "⚪ Baixa": "⚪ Baja",
  "⚠️ Atenção: dia de folga": "⚠️ Atención: día libre",
  "não trabalha": "no trabaja",
  "não trabalham": "no trabajan",
  "no dia escolhido. Você ainda pode agendar, mas confirme com a equipe antes.":
    "el día elegido. Aún puedes agendar, pero confirma con el equipo antes.",
  "Cancelar": "Cancelar",
  "Solicitações pendentes": "Solicitudes pendientes",
  "Nenhuma solicitação pendente. As novas aparecerão aqui.": "No hay solicitudes pendientes. Las nuevas aparecerán aquí.",
  "Arraste para o calendário para agendar": "Arrastra al calendario para agendar",
  "Sugerido:": "Sugerido:",
  "Pré-agendar solicitação": "Pre-agendar solicitud",
  "Solicitado:": "Solicitado:",
  "Data alvo": "Fecha objetivo",

  // ── Clientes ───────────────────────────────────────────────────────────
  "Carteira": "Cartera",
  "Localizar por nome, e-mail, telefone, endereço…": "Buscar por nombre, correo, teléfono, dirección…",
  "Ordenar clientes": "Ordenar clientes",
  "A → Z (nome)": "A → Z (nombre)",
  "Z → A (nome)": "Z → A (nombre)",
  "Mais recentes (criação)": "Más recientes (creación)",
  "Mais antigos (criação)": "Más antiguos (creación)",
  "Maior valor": "Mayor valor",
  "Menor valor": "Menor valor",
  "Ver mapa": "Ver mapa",
  "Novo cliente": "Nuevo cliente",
  "Novo Cliente": "Nuevo cliente",
  "Editar Cliente": "Editar cliente",
  "Nenhum cliente cadastrado ainda": "Aún no hay clientes registrados",
  "Clique em": "Haz clic en",
  "para começar.": "para comenzar.",
  "Nenhum cliente encontrado": "No se encontraron clientes",
  "Tente outros termos de busca ou": "Prueba otros términos de búsqueda o",
  "limpar filtro": "limpiar filtro",
  'Excluir cliente "{name}"?': '¿Eliminar al cliente "{name}"?',
  "Todas as limpezas relacionadas ainda serão preservadas no histórico, mas o cadastro do cliente será removido.":
    "Todas las limpiezas relacionadas se conservarán en el historial, pero el registro del cliente será eliminado.",
  "Excluir cliente": "Eliminar cliente",
  "Cliente excluído": "Cliente eliminado",
  "Endereço incompleto:": "Dirección incompleta:",
  "sem rua": "sin calle",
  "sem CEP/ZIP": "sin código postal",
  "e": "y",
  "⚠ Endereço incompleto": "⚠ Dirección incompleta",
  "Visualizar cliente": "Ver cliente",
  "Excluir": "Eliminar",
  "Residencial": "Residencial",
  "Comercial": "Comercial",
  "Condomínio": "Condominio",
  "Empresarial": "Corporativo",
  "Avulsa": "Única",
  "Semanal": "Semanal",
  "Quinzenal": "Quincenal",
  "Mensal": "Mensual",
  "Dados gerais": "Datos generales",
  "Cadastrar casa": "Datos de la casa",
  "Agendamento": "Agendamiento",
  "Cliente salvo": "Cliente guardado",
  "GPS recalculado": "GPS recalculado",
  "Nome Completo": "Nombre completo",
  "Nome Fantasia / Business Name": "Nombre comercial",
  "Para clientes comerciais (opcional)": "Para clientes comerciales (opcional)",
  "Canais de Contato Disponíveis": "Canales de contacto disponibles",
  "@ do Instagram": "Usuario de Instagram",
  "Perfil do Facebook": "Perfil de Facebook",
  "✓ Localização:": "✓ Ubicación:",
  "Recalcular GPS deste cliente?": "¿Recalcular el GPS de este cliente?",
  "Será usado o endereço atual (rua, cidade, estado, ZIP) para obter as coordenadas pelo OpenStreetMap.":
    "Se usará la dirección actual (calle, ciudad, estado, código postal) para obtener las coordenadas vía OpenStreetMap.",
  "Recalcular": "Recalcular",
  "↻ Recalcular pelo endereço": "↻ Recalcular por dirección",
  "Preencha o endereço abaixo — o mapa aparece após salvar.": "Completa la dirección abajo — el mapa aparece tras guardar.",
  "Endereço (rua e número)": "Dirección (calle y número)",
  "Nº do Apartamento": "N.º de apartamento",
  "Código da Porta": "Código de la puerta",
  "Tipo de Imóvel": "Tipo de propiedad",
  "Valor da Limpeza (US$)": "Valor de la limpieza (US$)",
  "↻ Recorrência Automática": "↻ Recurrencia automática",
  "Ao finalizar uma limpeza deste cliente, agendar automaticamente a próxima em":
    "Al finalizar una limpieza de este cliente, agendar automáticamente la próxima en",
  "7 dias": "7 días",
  "14 dias": "14 días",
  "com a mesma equipe.": "con el mismo equipo.",
  "Data de início do contrato (MM/DD/YYYY)": "Fecha de inicio del contrato (MM/DD/YYYY)",
  "Data final do contrato (MM/DD/YYYY) (opcional)": "Fecha final del contrato (MM/DD/YYYY) (opcional)",
  "ⓘ Após {date}, a recorrência automática não criará mais novos atendimentos. Os já agendados continuam.":
    "ⓘ Después del {date}, la recurrencia automática no creará nuevos servicios. Los ya agendados continúan.",
  "Observações da Casa (destaque para equipe)": "Notas de la casa (resaltadas para el equipo)",
  "Ex: cuidado com pets, usar produto X, não limpar quarto trancado…":
    "Ej.: cuidado con mascotas, usar producto X, no limpiar el cuarto cerrado…",
  "Idioma Falado pelo Cliente": "Idioma hablado por el cliente",
  "— não informado —": "— no informado —",
  "Checklist de Limpeza (itens padrão deste cliente)": "Lista de limpieza (elementos predeterminados de este cliente)",
  "Fotos do Local": "Fotos del lugar",
  "Salvar e agendar limpeza": "Guardar y agendar limpieza",
  "Adicionar à agenda": "Agregar a la agenda",
  "Nome": "Nombre",
  "Adicionar": "Agregar",
  "Sugestões Rápidas:": "Sugerencias rápidas:",
  "Aspirar carpetes": "Aspirar alfombras",
  "Limpar banheiros": "Limpiar baños",
  "Trocar roupas de cama": "Cambiar ropa de cama",
  "Lavar louça": "Lavar platos",
  "Limpar geladeira": "Limpiar refrigerador",
  "Tirar lixo": "Sacar la basura",
  "Limpar janelas": "Limpiar ventanas",
  "Passar pano no chão": "Trapear el piso",
  "Ex: Aspirar carpetes da sala": "Ej.: Aspirar las alfombras de la sala",
  "Subir": "Subir",
  "Descer": "Bajar",
  "Remover": "Quitar",

  // ── Equipes ────────────────────────────────────────────────────────────
  "Estrutura": "Estructura",
  "Nova equipe": "Nuevo equipo",
  'Excluir a equipe "{name}"?': '¿Eliminar el equipo "{name}"?',
  "Os equipamentos atribuídos voltarão para o estoque. Esta ação não pode ser desfeita.":
    "Los equipos asignados volverán al inventario. Esta acción no se puede deshacer.",
  "Excluir equipe": "Eliminar equipo",
  "Equipe excluída": "Equipo eliminado",
  "Considere renomear para algo memorável": "Considera renombrarlo a algo memorable",
  "Renomear": "Renombrar",
  "✓ Dia concluído": "✓ Día completado",
  "Líder:": "Líder:",
  "Ver casas no mapa": "Ver casas en el mapa",
  "Schedule semanal da equipe": "Agenda semanal del equipo",
  "Editar equipe": "Editar equipo",
  "Membros": "Miembros",
  "Casas atribuídas": "Casas asignadas",
  "Mapa de casas —": "Mapa de casas —",
  "de": "de",
  "casas com GPS capturado": "casas con GPS capturado",
  "Nenhuma casa desta equipe tem GPS capturado. Edite os clientes e recapture o endereço pelo autocomplete.":
    "Ninguna casa de este equipo tiene GPS capturado. Edita los clientes y recaptura la dirección con el autocompletado.",
  "Domingo": "Domingo",
  "Segunda": "Lunes",
  "Terça": "Martes",
  "Quarta": "Miércoles",
  "Quinta": "Jueves",
  "Sexta": "Viernes",
  "Sábado": "Sábado",
  "Schedule semanal —": "Agenda semanal —",
  "membros": "miembros",
  "Quem trabalha em cada dia da semana": "Quién trabaja cada día de la semana",
  "Esta equipe ainda não tem membros atribuídos.": "Este equipo aún no tiene miembros asignados.",
  "hoje": "hoy",
  "Folga": "Día libre",
  "pessoa": "persona",
  "pessoas": "personas",
  "Equipe salva": "Equipo guardado",
  "Nome da Equipe": "Nombre del equipo",
  "Cor da equipe": "Color del equipo",
  "Azul": "Azul",
  "Verde": "Verde",
  "Roxo": "Morado",
  "Rosa": "Rosa",
  "Laranja": "Naranja",
  "Vermelho": "Rojo",
  "Turquesa": "Turquesa",
  "Lima": "Lima",
  "Grafite": "Grafito",
  "Já usada por": "Ya usado por",
  "Cor selecionada:": "Color seleccionado:",
  "· cores com ✕ já estão em uso por outra equipe": "· los colores con ✕ ya están en uso por otro equipo",
  "Líder": "Líder",
  "— escolher —": "— elegir —",
  "Equipamentos da equipe": "Equipos del equipo",
  "Quantidade ↔ disponível": "Cantidad ↔ disponible",
  "Cadastre equipamentos no menu Equipamentos para distribuir.": "Registra equipos en el menú Equipos para distribuir.",
  "Disponível": "Disponible",
  "Salvar": "Guardar",
  "Cor": "Color",
  "Equipe renomeada": "Equipo renombrado",
  "Falha ao renomear": "Error al renombrar",
  "Clique para renomear": "Haz clic para renombrar",

  // ── Colaboradores ──────────────────────────────────────────────────────
  "Time": "Equipo",
  "Mostrar inativos": "Mostrar inactivos",
  "Histórico de convites": "Historial de invitaciones",
  "Convidar colaborador": "Invitar colaborador",
  "Novo colaborador": "Nuevo colaborador",
  "Editar colaborador": "Editar colaborador",
  "Colaborador reativado": "Colaborador reactivado",
  'Desativar colaborador "{name}"?': '¿Desactivar al colaborador "{name}"?',
  "O acesso ao sistema será removido e o colaborador não poderá mais ser atribuído a novas equipes ou limpezas. Os dados ficam guardados (pode reativar depois).":
    "Se removerá el acceso al sistema y el colaborador ya no podrá asignarse a nuevos equipos o limpiezas. Los datos se conservan (puedes reactivar después).",
  "Desativar": "Desactivar",
  "Colaborador desativado": "Colaborador desactivado",
  'Excluir permanentemente "{name}"?': '¿Eliminar permanentemente a "{name}"?',
  "Esta ação é DEFINITIVA. O colaborador será removido das equipes e apagado do banco de dados. As limpezas já realizadas continuam no histórico (com o nome em snapshot).":
    "Esta acción es DEFINITIVA. El colaborador será removido de los equipos y eliminado de la base de datos. Las limpiezas ya realizadas permanecen en el historial (con el nombre en captura).",
  "Excluir permanentemente": "Eliminar permanentemente",
  "{name} excluído permanentemente": "{name} eliminado permanentemente",
  "Falha ao excluir": "Error al eliminar",
  "1 colaborador(a) aguardando ativação": "1 colaborador(a) esperando activación",
  "{n} colaboradores aguardando ativação": "{n} colaboradores esperando activación",
  "e mais {n}": "y {n} más",
  "— defina cargo e dias de trabalho para ativar.": "— define cargo y días de trabajo para activar.",
  "Ver agora": "Ver ahora",
  "Onboarding em andamento ({n})": "Incorporación en progreso ({n})",
  "Continue de onde parou. Cada pessoa abaixo tem etapas faltando.":
    "Continúa donde lo dejaste. Cada persona abajo tiene pasos pendientes.",
  "(sem nome)": "(sin nombre)",
  "Falta": "Falta",
  "Cargo": "Cargo",
  "Dias": "Días",
  "Continuar": "Continuar",
  "Localizar por nome, e-mail, telefone ou cargo…": "Buscar por nombre, correo, teléfono o cargo…",
  "Ordenar colaboradores": "Ordenar colaboradores",
  "Por cargo": "Por cargo",
  "Por função (admin/colaborador)": "Por rol (admin/colaborador)",
  "Nenhum colaborador encontrado para": "No se encontraron colaboradores para",
  "Defina cargo/equipe e reative para liberar o acesso": "Define cargo/equipo y reactiva para habilitar el acceso",
  "⚠ Aguardando ativação": "⚠ Esperando activación",
  "ativo": "activo",
  "inativo": "inactivo",
  "Reativar": "Reactivar",
  "Visualizar": "Ver",
  "Desativar (soft delete)": "Desactivar (borrado suave)",
  "Valor por dia": "Tarifa por día",
  "não informado": "no informado",
  "📅 Dias de trabalho": "📅 Días de trabajo",
  "Todos os dias": "Todos los días",
  "Cargo:": "Cargo:",
  "Fechar": "Cerrar",
  "Colaborador salvo": "Colaborador guardado",
  "Dados": "Datos",
  "Cargo + dias": "Cargo + días",
  "Para ativar esta pessoa, complete as etapas acima — defina cargo e dias de trabalho destacados em amarelo abaixo, escolha uma equipe, agende a primeira semana e clique em Salvar.":
    "Para activar a esta persona, completa los pasos de arriba — define cargo y días de trabajo resaltados en amarillo abajo, elige un equipo, agenda la primera semana y haz clic en Guardar.",
  "Alterar o e-mail também muda o login do colaborador.": "Cambiar el correo también cambia el inicio de sesión del colaborador.",
  "Senha (deixe vazio para manter)": "Contraseña (déjala vacía para mantenerla)",
  "Cargo / Função": "Cargo / Función",
  "— selecione —": "— selecciona —",
  "Colaborador(a)": "Colaborador(a)",
  "Ativo": "Activo",
  "Inativo": "Inactivo",
  "Valor por dia (US$)": "Tarifa por día (US$)",
  "@usuario, telefone ou e-mail": "@usuario, teléfono o correo",
  "Dias de trabalho na semana": "Días de trabajo de la semana",
  "Foto": "Foto",
  "Cargo de acesso": "Rol de acceso",
  "adicionado à equipe": "agregado al equipo",
  "Falha ao adicionar à equipe": "Error al agregar al equipo",
  "Nenhuma limpeza nova para gerar (todas já agendadas ou equipe sem clientes).":
    "No hay limpiezas nuevas para generar (todas ya agendadas o el equipo sin clientes).",
  "{n} limpeza(s) agendada(s) para os próximos 7 dias": "{n} limpieza(s) agendada(s) para los próximos 7 días",
  "Falha ao gerar escala": "Error al generar la programación",
  "Adicionado(a) à equipe": "Agregado(a) al equipo",
  "{n} limpeza(s) agendada(s) nos próximos 7 dias para {team}.": "{n} limpieza(s) agendada(s) en los próximos 7 días para {team}.",
  "Nenhuma limpeza nova para gerar (já cobertas ou equipe sem clientes).":
    "No hay limpiezas nuevas para generar (ya cubiertas o el equipo sin clientes).",
  "Avisar pelo WhatsApp": "Avisar por WhatsApp",
  "Quer já agendar a primeira semana de limpezas com base nos dias de trabalho dele(a)?":
    "¿Quieres agendar ya la primera semana de limpiezas según sus días de trabajo?",
  "Agendando…": "Agendando…",
  "Agendar semana": "Agendar semana",
  "Pular — agendar depois": "Saltar — agendar después",
  "Sugestão: adicionar à equipe": "Sugerencia: agregar al equipo",
  "Equipe sem membros ainda — boa para começar.": "Equipo sin miembros aún — bueno para comenzar.",
  "{n} membro(s) atualmente — equipe com mais capacidade.": "{n} miembro(s) actualmente — equipo con más capacidad.",
  "Outras opções:": "Otras opciones:",
  "Pular esta etapa — configurar depois": "Saltar este paso — configurar después",
  "Adicionando…": "Agregando…",
  "📅 Schedule semanal da equipe": "📅 Agenda semanal del equipo",
  "colaboradores ativos": "colaboradores activos",
  "Próxima semana": "Próxima semana",
  "Ninguém": "Nadie",
  "jan": "Ene", "fev": "Feb", "mar": "Mar", "abr": "Abr", "mai": "May", "jun": "Jun",
  "jul": "Jul", "ago": "Ago", "set": "Sep", "out": "Oct", "nov": "Nov", "dez": "Dic",
  "agora": "ahora",
  "{n}h atrás": "hace {n}h",
  "{n}d atrás": "hace {n}d",
  "convite aguardando aprovação": "invitación esperando aprobación",
  "convites aguardando aprovação": "invitaciones esperando aprobación",
  "Colaboradores que enviaram seus dados via link de convite.": "Colaboradores que enviaron sus datos por el enlace de invitación.",
  "Sem nome": "Sin nombre",
  "Revisar e aprovar": "Revisar y aprobar",
  "Rejeitar este convite?": "¿Rechazar esta invitación?",
  "Convite rejeitado": "Invitación rechazada",
  "Revisar dados do colaborador": "Revisar datos del colaborador",
  "Confira os dados enviados. Após aprovar, o colaborador será criado como inativo — defina o cargo e a equipe antes de ativar o acesso.":
    "Revisa los datos enviados. Tras aprobar, el colaborador se creará como inactivo — define el cargo y el equipo antes de activar el acceso.",
  "Convite aprovado! Defina cargo e dias de trabalho abaixo.": "¡Invitación aprobada! Define cargo y días de trabajo abajo.",
  "Falha ao aprovar": "Error al aprobar",
  "Aprovando…": "Aprobando…",
  "Aprovar e criar colaborador": "Aprobar y crear colaborador",
  "Para qual colaborador é este convite? O nome ajuda você a identificar no histórico.":
    "¿Para qué colaborador es esta invitación? El nombre te ayuda a identificarla en el historial.",
  "Nome do colaborador (opcional)": "Nombre del colaborador (opcional)",
  "Ex.: João Silva": "Ej.: Juan Pérez",
  "Gerando convite…": "Generando invitación…",
  "Gerar convite": "Generar invitación",
  "Falha ao gerar convite": "Error al generar la invitación",
  "copiado": "copiado",
  "Código": "Código",
  "Convite para": "Invitación para",
  "Envie o link ou código abaixo. Validade:": "Envía el enlace o código de abajo. Validez:",
  "Envie este link ou código para o colaborador. Ele preenche os dados sozinho e você aprova depois. Validade:":
    "Envía este enlace o código al colaborador. Él completa sus datos y tú lo apruebas después. Validez:",
  "Link do convite": "Enlace de invitación",
  "Código curto": "Código corto",
  "Todos": "Todos",
  "Pendentes": "Pendientes",
  "Aguardando": "Esperando",
  "Aprovados": "Aprobados",
  "Rejeitados": "Rechazados",
  "Expirados": "Expirados",
  "Revogados": "Revocados",
  "Aguardando preenchimento": "Esperando que se complete",
  "Aguardando aprovação": "Esperando aprobación",
  "Aprovado": "Aprobado",
  "Rejeitado": "Rechazado",
  "Expirado": "Expirado",
  "Revogado": "Revocado",
  "Revogar este convite? O link deixará de funcionar.": "¿Revocar esta invitación? El enlace dejará de funcionar.",
  "Convite revogado": "Invitación revocada",
  "Link copiado": "Enlace copiado",
  "Nenhum convite": "Sin invitaciones",
  "com status": "con estado",
  "(sem nome cadastrado)": "(sin nombre registrado)",
  "Criado:": "Creado:",
  "Preenchido:": "Completado:",
  "Expira:": "Expira:",
  "Copiar link": "Copiar enlace",
  "Revogar": "Revocar",

  // ── Financeiro ─────────────────────────────────────────────────────────
  "Pagamentos & Faturamento": "Pagos y facturación",
  "📊 Ver Relatórios Detalhados (Equipe/Colaborador/Cliente + PDF) →": "📊 Ver reportes detallados (Equipo/Colaborador/Cliente + PDF) →",
  "De": "Desde",
  "Até": "Hasta",
  "A pagar (folha)": "Por pagar (nómina)",
  "Produtos / Despesas": "Productos / Gastos",
  "Lucro estimado": "Ganancia estimada",
  "Limpezas finalizadas": "Limpiezas finalizadas",
  "Produtos & compras": "Productos y compras",
  "Kits de compra": "Kits de compra",
  "Nova compra": "Nueva compra",
  "Nenhuma compra registrada no período.": "No hay compras registradas en el período.",
  "Excluir esta compra/despesa?": "¿Eliminar esta compra/gasto?",
  "Despesa excluída": "Gasto eliminado",
  "produto": "producto",
  "equipamento": "equipo",
  "uniforme": "uniforme",
  "outro": "otro",
  "Produto / Item": "Producto / Artículo",
  "Categoria": "Categoría",
  "Fornecedor": "Proveedor",
  "Qtd": "Cant.",
  "Preço unit.": "Precio unit.",
  "Pagamentos a colaboradores": "Pagos a colaboradores",
  "Nenhum pagamento no período.": "No hay pagos en el período.",
  "Casas": "Casas",
  "Valor / dia": "Valor / día",
  "Editar compra": "Editar compra",
  "Nova compra / produto": "Nueva compra / producto",
  "Despesa registrada": "Gasto registrado",
  "Ex: Detergente, Pano de microfibra…": "Ej.: Detergente, paño de microfibra…",
  "Produto de limpeza": "Producto de limpieza",
  "Equipamento": "Equipo",
  "Uniforme / EPI": "Uniforme / EPP",
  "Outro": "Otro",
  "Ex: Walmart, Costco, Home Depot…": "Ej.: Walmart, Costco, Home Depot…",
  "Quantidade": "Cantidad",
  "Preço Unitário (US$)": "Precio unitario (US$)",
  "Total da compra": "Total de la compra",

  // ── Recebimentos ───────────────────────────────────────────────────────
  "Em atraso": "Atrasado",
  "Vence em breve": "Vence pronto",
  "Em dia": "Al día",
  "Acompanhe pagamentos previstos por cliente. Quem está em atraso, quem vai vencer e quem está em dia.":
    "Da seguimiento a los pagos previstos por cliente. Quién está atrasado, quién vencerá y quién está al día.",
  "Valor em atraso": "Monto atrasado",
  "Buscar cliente ou endereço…": "Buscar cliente o dirección…",
  "Nenhum cliente nesse filtro.": "No hay clientes en este filtro.",
  "Para registrar cobranças, defina o": "Para registrar cobros, define el",
  "dia de pagamento": "día de pago",
  "valor": "valor",
  "em cada cliente.": "en cada cliente.",
  "Ir para clientes →": "Ir a clientes →",
  "Vencimento": "Vencimiento",
  "dia atrás": "día atrás",
  "dias atrás": "días atrás",
  "Registrar": "Registrar",
  "Lembrete de pagamento": "Recordatorio de pago",
  "Pagamento registrado": "Pago registrado",
  "Registrar pagamento —": "Registrar pago —",
  "Valor recebido": "Monto recibido",
  "Referente ao vencimento de": "Correspondiente al vencimiento del",
  "Método": "Método",
  "Dinheiro": "Efectivo",
  "Cheque": "Cheque",
  "Salvando…": "Guardando…",
  "Falha ao gerar link": "Error al generar el enlace",
  "Não foi possível copiar": "No se pudo copiar",
  "Cobrar": "Cobrar",
  "Gerar link de pagamento": "Generar enlace de pago",
  "via Stripe Checkout (cartão de crédito).": "vía Stripe Checkout (tarjeta de crédito).",
  "Valor a cobrar (USD)": "Monto a cobrar (USD)",
  "Gerar link": "Generar enlace",
  "Link gerado": "Enlace generado",
  "Copiar": "Copiar",
  "O pagamento é registrado automaticamente quando o cliente concluir.":
    "El pago se registra automáticamente cuando el cliente lo complete.",

  // ── Signup / Recuperação ───────────────────────────────────────────────
  "A senha precisa ter ao menos 6 caracteres": "La contraseña debe tener al menos 6 caracteres",
  "As senhas não coincidem": "Las contraseñas no coinciden",
  'Empresa "{name}" criada! Você tem 14 dias de trial.': '¡Empresa "{name}" creada! Tienes 14 días de prueba.',
  "Falha ao criar empresa": "Error al crear la empresa",
  "14 dias grátis · sem cartão": "14 días gratis · sin tarjeta",
  "A operação da sua empresa de limpeza,": "La operación de tu empresa de limpieza,",
  "no piloto automático": "en piloto automático",
  "Agende equipes, valide geolocalização, mande recibos no WhatsApp e controle financeiro — tudo em um só lugar.":
    "Agenda equipos, valida la geolocalización, envía recibos por WhatsApp y controla las finanzas — todo en un solo lugar.",
  "Seus dados, isolados": "Tus datos, aislados",
  "Cada empresa só vê seus próprios clientes, colaboradores e finanças.":
    "Cada empresa solo ve sus propios clientes, colaboradores y finanzas.",
  "Pronto em 30 segundos": "Listo en 30 segundos",
  "Crie sua conta, convide seu primeiro colaborador e comece a agendar.":
    "Crea tu cuenta, invita a tu primer colaborador y empieza a agendar.",
  "Personalize logo, cores e dados da empresa para recibos e PDFs.":
    "Personaliza el logo, los colores y los datos de la empresa para recibos y PDFs.",
  "Criar minha empresa": "Crear mi empresa",
  "Em menos de 1 minuto você está agendando a primeira limpeza.": "En menos de 1 minuto estarás agendando tu primera limpieza.",
  "Nome da empresa": "Nombre de la empresa",
  "Ex.: Clean Manager USA": "Ej.: Clean Manager USA",
  "Seu nome": "Tu nombre",
  "Ex.: Maria Silva": "Ej.: María García",
  "E-mail (será seu login)": "Correo (será tu inicio de sesión)",
  "Telefone (opcional)": "Teléfono (opcional)",
  "Mínimo 6 caracteres": "Mínimo 6 caracteres",
  "Confirmar senha": "Confirmar contraseña",
  "Digite novamente": "Escríbela de nuevo",
  "Criando empresa…": "Creando empresa…",
  "Criar empresa com Google": "Crear empresa con Google",
  "Já tem conta?": "¿Ya tienes cuenta?",
  "Recuperar senha": "Recuperar contraseña",
  "Se este e-mail existir, geramos um link de recuperação (verifique os logs do servidor em ambiente de teste).":
    "Si este correo existe, generamos un enlace de recuperación (revisa tu bandeja de entrada).",
  "Enviar link": "Enviar enlace",
  "Voltar ao login": "Volver al inicio de sesión",
  "Definir nova senha": "Definir nueva contraseña",
  "Senha alterada": "Contraseña cambiada",
  "Nova Senha": "Nueva contraseña",
  "Alterar senha": "Cambiar contraseña",

  // ── Perfil ─────────────────────────────────────────────────────────────
  "Minha conta": "Mi cuenta",
  "Perfil": "Perfil",
  "Foto de reconhecimento": "Foto de identificación",
  "Usada nos crachás, mapas e relatórios. Mesma foto que os colaboradores usam.":
    "Se usa en credenciales, mapas y reportes. La misma foto que usan los colaboradores.",
  "Dados pessoais": "Datos personales",
  "Nome completo": "Nombre completo",
  "Telefone (US)": "Teléfono (US)",
  "(criptografado · só você vê)": "(cifrado · solo tú lo ves)",
  "ocultar": "ocultar",
  "mostrar": "mostrar",
  "Endereço": "Dirección",
  "Rua e número": "Calle y número",
  "Apto / Suite": "Apto / Suite",
  "Cidade": "Ciudad",
  "Estado": "Estado",
  "Dados da empresa": "Datos de la empresa",
  "Informações que aparecem nos invoices, recibos e PDFs.": "Información que aparece en facturas, recibos y PDFs.",
  "Razão social": "Razón social",
  "Telefone": "Teléfono",
  "Login com Google": "Inicio con Google",
  "Trocar senha (opcional)": "Cambiar contraseña (opcional)",
  "Senha atual": "Contraseña actual",
  "Nova senha": "Nueva contraseña",
  "Salvar alterações": "Guardar cambios",
  "Informe a senha atual para trocar": "Indica la contraseña actual para cambiarla",
  "Perfil atualizado": "Perfil actualizado",
  "Redes sociais": "Redes sociales",
  "Marque as redes que você usa — os campos aparecem conforme você seleciona.":
    "Marca las redes que usas — los campos aparecen a medida que seleccionas.",
  "Selecione acima as redes que você usa.": "Selecciona arriba las redes que usas.",
  "Conta conectada com Google": "Cuenta conectada con Google",
  "Você pode entrar usando o botão 'Entrar com Google' na tela de login.":
    "Puedes ingresar usando el botón 'Ingresar con Google' en la pantalla de inicio de sesión.",
  "Conecte seu Google para entrar com 1 clique (mesmo e-mail).": "Conecta tu Google para ingresar con 1 clic (mismo correo).",
  "Desconectar": "Desconectar",
  "Conectar com Google": "Conectar con Google",
  "Conta Google desconectada": "Cuenta de Google desconectada",
  "Idioma do sistema": "Idioma del sistema",
  "Escolha o idioma da interface. A preferência fica salva no seu perfil.":
    "Elige el idioma de la interfaz. Tu preferencia se guarda en tu perfil.",
  "Idioma atualizado": "Idioma actualizado",

  // ── Hoje / TodayOverview ───────────────────────────────────────────────
  "Operações": "Operaciones",
  "Atualiza automaticamente a cada 30s.": "Se actualiza automáticamente cada 30s.",
  "Carregando dados…": "Cargando datos…",
  "Concluídas": "Completadas",
  "Próximas": "Próximas",
  "Faturamento": "Ingresos",
  "previsto": "previsto",
  "Progresso do dia": "Progreso del día",
  "Mapa ao vivo": "Mapa en vivo",
  "equipe(s) em campo": "equipo(s) en campo",
  "Próximas limpezas": "Próximas limpiezas",
  "Nenhuma limpeza agendada nas próximas horas.": "No hay limpiezas agendadas en las próximas horas.",
  "Endereço não informado": "Dirección no informada",
  "equipes sem job ativo ou agendado nas próximas 2h": "equipos sin trabajo activo o agendado en las próximas 2h",
  "equipe sem job ativo ou agendado nas próximas 2h": "equipo sin trabajo activo o agendado en las próximas 2h",
  "Considere distribuir uma limpeza não agendada ou liberar o time.": "Considera asignar una limpieza pendiente o liberar al equipo.",
  "Limpezas sem equipe": "Limpiezas sin equipo",
  "Aloque uma equipe antes do horário": "Asigna un equipo antes del horario",
  "Atrasadas (não iniciaram)": "Atrasadas (no iniciaron)",
  "Ligue para o colaborador e confirme se vai começar": "Llama al colaborador y confirma si va a empezar",
  "Faturas vencidas": "Facturas vencidas",
  "Envie cobrança ou link de pagamento": "Envía un cobro o enlace de pago",
  "vence": "vence",
  "Agendamentos pendentes": "Agendamientos pendientes",
  "Cliente pediu via portal — aprove ou recuse": "El cliente solicitó vía portal — aprueba o rechaza",
  "alertas requerem sua atenção": "alertas requieren tu atención",
  "alerta requer sua atenção": "alerta requiere tu atención",
  "Ver tudo →": "Ver todo →",
  "outros": "otros",

  // ── Liberação manual por dia ───────────────────────────────────────────
  "Aguardando liberação da agenda de hoje": "Esperando la liberación de la agenda de hoy",
  "Assim que o administrador liberar, suas casas aparecem aqui automaticamente.":
    "Apenas el administrador la libere, tus casas aparecerán aquí automáticamente.",

  // ── Schedule modal (Edit/Delete) ───────────────────────────────────────
  "Cliente removido": "Cliente removido",
  "Equipe removida": "Equipo removido",
  "Excluir definitivamente?": "¿Eliminar definitivamente?",
  "Apenas esta ocorrência é apagada do banco. As demais permanecem.":
    "Solo esta ocurrencia se elimina de la base. Las demás permanecen.",
  "Atendimento excluído": "Servicio eliminado",
  "Limpar agendamentos órfãos?": "¿Limpiar agendamientos huérfanos?",
  "Esta ação apaga todos os agendamentos cujo cliente OU equipe não existe mais no sistema. Útil quando você apagou um cliente/equipe e ficaram limpezas fantasmas na agenda. Não pode ser desfeito.":
    "Esta acción elimina todos los agendamientos cuyo cliente O equipo ya no existe en el sistema. Útil cuando eliminaste un cliente/equipo y quedaron limpiezas fantasma en la agenda. No se puede deshacer.",
  "Limpar todos": "Limpiar todos",
  "agendamento(s) órfão(s)": "agendamiento(s) huérfano(s)",
  "agendamento(s) órfão(s) removido(s)": "agendamiento(s) huérfano(s) removido(s)",
  "cliente ou equipe foi apagado mas os agendamentos ficaram na agenda.":
    "el cliente o equipo fue eliminado pero los agendamientos quedaron en la agenda.",
  "Falha ao limpar": "Error al limpiar",

  // ── Recebimentos (Edit/Delete) ─────────────────────────────────────────
  "Excluir cobrança recorrente?": "¿Eliminar cobro recurrente?",
  "Esta ação removerá a configuração de cobrança (dia de vencimento e valor) do cliente {name}. Ele deixará de aparecer nesta lista. As limpezas e pagamentos já registrados serão mantidos.":
    "Esta acción eliminará la configuración de cobro (día de vencimiento y monto) del cliente {name}. Dejará de aparecer en esta lista. Las limpiezas y pagos ya registrados se conservan.",
  "Cobrança removida": "Cobro eliminado",

  // ── Reports ────────────────────────────────────────────────────────────
  "Análises": "Análisis",
  "Limpezas no período": "Limpiezas en el período",
  "Tempo médio": "Tiempo promedio",
  "Limpezas por dia": "Limpiezas por día",
  "Produtividade por equipe": "Productividad por equipo",
  "(colab.)": "(colab.)",

  // ── Positions (Cargos) ─────────────────────────────────────────────────
  "Cargos & Funções": "Cargos y funciones",
  "Cadastre os cargos usados ao registrar colaboradores": "Registra los cargos usados al registrar colaboradores",
  "Novo cargo": "Nuevo cargo",
  "Excluir cargo": "Eliminar cargo",
  "Cargo excluído": "Cargo eliminado",
  "Editar cargo": "Editar cargo",
  "Cargo salvo": "Cargo guardado",
  "Valor padrão / dia": "Valor predeterminado / día",
  "Nenhum cargo cadastrado.": "No hay cargos registrados.",
  "Nome do Cargo": "Nombre del cargo",
  "Ex: Faxineira, Líder de equipe…": "Ej.: Personal de limpieza, Líder de equipo…",
  "O que esse cargo faz na operação": "Qué hace este cargo en la operación",
  "Valor Padrão por Dia (US$)": "Valor predeterminado por día (US$)",

  // ── Equipments ─────────────────────────────────────────────────────────
  "Cadastre os equipamentos e a quantidade total disponível": "Registra los equipos y la cantidad total disponible",
  "Novo equipamento": "Nuevo equipo",
  "Equipamento excluído": "Equipo eliminado",
  "Esta ação não pode ser desfeita.": "Esta acción no se puede deshacer.",

  // ── Supplies ───────────────────────────────────────────────────────────
  "Cadastre os consumíveis (produtos, químicos, descartáveis, EPI) e controle o estoque":
    "Registra los consumibles (productos, químicos, desechables, EPP) y controla el stock",
  "Lista de reposição": "Lista de reposición",
  "Novo item": "Nuevo artículo",
  "Item excluído": "Artículo eliminado",
  "Todo o histórico de movimentações deste item será apagado também. Esta ação não pode ser desfeita.":
    "Todo el historial de movimientos de este artículo también se eliminará. Esta acción no se puede deshacer.",
  "item(ns) abaixo ou no estoque mínimo.": "artículo(s) en o por debajo del stock mínimo.",

  // ── Notifications (List + Settings + History) ──────────────────────────
  "Notificações ao cliente": "Notificaciones al cliente",
  "sem ler": "sin leer",
  "Eventos do sistema: agendamentos, check-ins, pagamentos, limpezas finalizadas e alertas.":
    "Eventos del sistema: agendamientos, check-ins, pagos, limpiezas finalizadas y alertas.",
  "Todas": "Todas",
  "Sem ler": "Sin leer",
  "Marcar todas como lidas": "Marcar todas como leídas",
  "Anteriores": "Anteriores",
  "Nova solicitação": "Nueva solicitud",
  "Check-in colaborador": "Check-in colaborador",
  "Pagamento": "Pago",
  "Alerta": "Alerta",
  "Notificação": "Notificación",
  "Novo": "Nuevo",
  "Ver →": "Ver →",
  "Marcar lido": "Marcar como leído",
  "Tudo em dia! Nenhuma notificação não lida.": "¡Todo al día! No hay notificaciones sin leer.",
  "Sua caixa de entrada está vazia": "Tu bandeja de entrada está vacía",
  "Aqui aparecem os eventos do sistema: novos agendamentos, check-ins, pagamentos recebidos, limpezas finalizadas e alertas operacionais.":
    "Aquí aparecen los eventos del sistema: nuevos agendamientos, check-ins, pagos recibidos, limpiezas finalizadas y alertas operativas.",

  // NotificationSettings
  "Erro ao carregar configurações": "Error al cargar la configuración",
  "Configurações salvas": "Configuración guardada",
  "Erro ao salvar": "Error al guardar",
  "Disparada quando um cliente é cadastrado ou uma nova limpeza é agendada.":
    "Se dispara cuando se registra un cliente o se agenda una nueva limpieza.",
  "Disparada 1 dia antes da limpeza agendada como lembrete.":
    "Se dispara 1 día antes de la limpieza agendada como recordatorio.",
  "Disparada quando o colaborador clica em \"START\" no app mobile.":
    "Se dispara cuando el colaborador toca \"START\" en la app móvil.",
  "Disparada quando a limpeza é finalizada (envia também o PDF do comprovante quando disponível).":
    "Se dispara cuando la limpieza se finaliza (también envía el PDF del comprobante cuando está disponible).",
  "Nome do cliente": "Nombre del cliente",
  "Data da limpeza (MM/DD/AAAA)": "Fecha de la limpieza (MM/DD/AAAA)",
  "Horário da limpeza (ex: 10:00 AM)": "Horario de la limpieza (ej.: 10:00 AM)",
  "Nome da equipe responsável": "Nombre del equipo responsable",
  "Configure templates de mensagem para WhatsApp/SMS. As mensagens são enviadas via link direto wa.me/sms — você confirma o envio com 1 clique no app do WhatsApp.":
    "Configura plantillas de mensaje para WhatsApp/SMS. Los mensajes se envían vía enlace directo wa.me/sms — confirmas el envío con 1 clic en la app de WhatsApp.",
  "Salvar configurações": "Guardar configuración",
  "Variáveis disponíveis nos templates:": "Variables disponibles en las plantillas:",
  "Template da mensagem": "Plantilla del mensaje",
  "Digite a mensagem...": "Escribe el mensaje...",
  "Preview": "Vista previa",
  "Como usar:": "Cómo usar:",
  "Após salvar, vá em uma limpeza, clique no botão": "Después de guardar, abre una limpieza y toca el botón",
  "Notificar cliente": "Notificar al cliente",
  "e o WhatsApp/SMS abrirá com a mensagem do template já preenchida com os dados do cliente. Basta clicar enviar.":
    "y WhatsApp/SMS se abrirá con el mensaje de la plantilla ya completado con los datos del cliente. Solo toca enviar.",

  // NotificationHistory
  "Histórico de notificações": "Historial de notificaciones",
  "Registro de mensagens enviadas (manual via WhatsApp/SMS) e lembretes automáticos pendentes (gerados pelo cron a cada 30 min).":
    "Registro de mensajes enviados (manual vía WhatsApp/SMS) y recordatorios automáticos pendientes (generados por el cron cada 30 min).",
  "Apagar tudo": "Borrar todo",
  "Período:": "Período:",
  "Última semana": "Última semana",
  "Este mês": "Este mes",
  "Este ano": "Este año",
  "registro": "registro",
  "registros": "registros",
  "Tipo:": "Tipo:",
  "Confirmação": "Confirmación",
  "Lembrete": "Recordatorio",
  "Equipe chegou": "Equipo llegó",
  "Concluída": "Finalizada",
  "Recibo de pagamento": "Recibo de pago",
  "Invoice": "Factura",
  "Invoice (Fatura)": "Factura",
  "WhatsApp": "WhatsApp",
  "SMS": "SMS",
  "Cron (pendente)": "Cron (pendiente)",
  "Destinatário": "Destinatario",
  "Canal": "Canal",
  "Enviado por": "Enviado por",
  "Mensagem": "Mensaje",
  "Nenhuma notificação enviada ainda.": "Aún no se ha enviado ninguna notificación.",
  "Nenhum registro neste tipo. Tente outro filtro.": "No hay registros de este tipo. Prueba otro filtro.",
  "Excluir notificação": "Eliminar notificación",
  "Digite sua senha de admin para confirmar a exclusão.": "Escribe tu contraseña de admin para confirmar la eliminación.",
  "Senha do admin": "Contraseña del admin",
  "Confirmar exclusão": "Confirmar eliminación",
  "Apagar TODO o histórico": "Borrar TODO el historial",
  "Esta ação é irreversível. Todos os {count} registros serão removidos. Digite sua senha de admin para confirmar.":
    "Esta acción es irreversible. Se removerán los {count} registros. Escribe tu contraseña de admin para confirmar.",
  "Notificação excluída": "Notificación eliminada",
  "notificações apagadas": "notificaciones borradas",
  "Erro": "Error",

  // FinanceReports
  "Por Equipe": "Por equipo",
  "Por Colaborador": "Por colaborador",
  "Por Cliente": "Por cliente",
  "início": "inicio",
  "Custom": "Personalizado",
  "Limpezas": "Limpiezas",
  "A pagar (colaboradores)": "Por pagar (colaboradores)",
  "Imprimir PDF": "Imprimir PDF",
  "Sem limpezas finalizadas no período.": "No hay limpiezas finalizadas en el período.",
  "Faturado": "Facturado",
  "Invoice gerado": "Factura generada",
  "Erro ao gerar invoice": "Error al generar la factura",
  "Baixar invoice em PDF": "Descargar factura en PDF",
  "Invoice PDF": "Factura PDF",
  "Nenhum cliente com limpezas finalizadas.": "No hay clientes con limpiezas finalizadas.",
  "limpeza": "limpieza",
  "limpezas": "limpiezas",
  "Total pago": "Total pagado",

  // StatusColors
  "Personalização": "Personalización",
  "Cores das atividades": "Colores de las actividades",
  "Personalize as cores que aparecem na agenda, dashboard e cards conforme o status da limpeza": "Personaliza los colores que aparecen en la agenda, el panel y las tarjetas según el estado de la limpieza",
  "Escolha a cor": "Elige el color",
  "Cor personalizada": "Color personalizado",
  "Descrição (opcional)": "Descripción (opcional)",
  "Salvando...": "Guardando...",
  'Cor de "{label}" salva': 'Color de "{label}" guardado',
  // BookingRequests
  "Aprovadas": "Aprobadas",
  "Agendadas": "Agendadas",
  "Recusadas": "Rechazadas",
  "Em análise": "En revisión",
  "Aprovada": "Aprobada",
  "Recusada": "Rechazada",
  "Solicitações de Agendamento": "Solicitudes de agendamiento",
  "Pedidos enviados pelos clientes via portal.": "Solicitudes enviadas por los clientes vía portal.",
  "Limpar testes": "Limpiar datos de prueba",
  "Nenhuma solicitação encontrada.": "No se encontraron solicitudes.",
  "Data preferida": "Fecha preferida",
  "Enviado em": "Enviado el",
  "Sua resposta:": "Tu respuesta:",
  "Aprovar": "Aprobar",
  "Marcar como Agendada": "Marcar como agendada",
  "Recusar": "Rechazar",
  "Solicitação atualizada": "Solicitud actualizada",
  "Solicitação excluída": "Solicitud eliminada",
  "Excluir solicitação?": "¿Eliminar solicitud?",
  "Motivo da recusa (opcional, será mostrado ao cliente):": "Motivo del rechazo (opcional, se mostrará al cliente):",
  "Nenhuma solicitação de teste encontrada": "No se encontraron solicitudes de prueba",
  "Excluir testes": "Eliminar datos de prueba",
  // JobDetail
  "Notas do cliente (todas as visitas)": "Notas del cliente (todas las visitas)",
  // Agendamento (ScheduleOnboardingForm)
  "Atualizar agenda": "Actualizar agenda",
  "Rotina ativa": "Rutina activa",
  "Este cliente tem uma rotina de limpeza configurada": "Este cliente tiene una rutina de limpieza configurada",
  "Filtrar por rotina": "Filtrar por rutina",
  "Todas as rotinas": "Todos los clientes",
  "Com rotina ativa": "Con rutina activa",
  "Sem rotina": "Sin rutina",
  "{without} de {total} clientes ainda sem rotina": "{without} de {total} clientes aún sin rutina",
  "Mostrando só os sem rotina — clique para ver todos.": "Mostrando solo los clientes sin rutina — haz clic para ver todos.",
  "Configure uma agenda recorrente e transforme em receita previsível. Clique para filtrar.": "Configura una agenda recurrente y conviértela en ingresos predecibles. Haz clic para filtrar.",
  "{count} de {total} clientes sem rotina recorrente": "{count} de {total} clientes sin rutina recurrente",
  "Configure agendas recorrentes e transforme em receita previsível.": "Configura agendas recurrentes y conviértelas en ingresos predecibles.",
  "Configurar →": "Configurar →",
  "Marcar dia como concluído": "Marcar el día como completado",
  "Dia concluído — {n} casa(s) marcadas como feitas": "Día completado — {n} casa(s) marcadas como hechas",
  "Falha ao concluir o dia": "Error al completar el día",
  "Dia fechado por {name}": "Día cerrado por {name}",
  "casa(s)": "casa(s)",
  "Progresso do dia por equipe": "Progreso del día por equipo",
  "em campo": "en campo",
  "pendentes": "pendientes",
  "Filtrar por equipe": "Filtrar por equipo",
  "Todas as equipes": "Todos los equipos",
  "Colaborador salvo · senha atualizada": "Colaborador guardado · contraseña actualizada",
  "O campo fica em branco por segurança. Digite uma nova senha para trocar; deixe vazio para manter a atual.": "El campo queda vacío por seguridad. Escribe una nueva contraseña para cambiarla; déjala vacía para mantener la actual.",
  "Senha forte gerada e copiada": "Contraseña segura generada y copiada",
  "Gerar senha forte": "Generar contraseña segura",
  "Gerar": "Generar",
  "Copiar senha": "Copiar contraseña",
  "Senha copiada": "Contraseña copiada",
  "Digite ou gere uma senha primeiro": "Escribe o genera una contraseña primero",

  // ── Estimates / Invoice ─────────────────────────────────────────────────
  "Editar orçamento": "Editar cotización",
  "Novo orçamento": "Nueva cotización",
  "Preparado por": "Preparado por",
  "Orçamento para": "Cotización para",
  "Pets": "Mascotas",
  "Nome do(s) Pet(s)": "Nombre de la(s) mascota(s)",
  "Tipo de imóvel": "Tipo de propiedad",
  "Especifique o tipo…": "Especifica el tipo…",
  "Nº de Quartos": "N.º de habitaciones",
  "Nº de Banheiros": "N.º de baños",
  "Metragem (sqft)": "Superficie (sqft)",
  "Cômodos a serem limpos": "Habitaciones a limpiar",
  "Outros cômodos…": "Otras habitaciones…",
  "Tipo de limpeza": "Tipo de limpieza",
  "Especifique…": "Especifica…",
  "Dias preferidos": "Días preferidos",
  "Horário preferido": "Horario preferido",
  "Você fornecerá os produtos de limpeza?": "¿Proporcionarás los productos de limpieza?",
  "Serviços adicionais": "Servicios adicionales",
  "Tarifas (US$)": "Tarifas (US$)",
  "Por limpeza semanal": "Por limpieza semanal",
  "Por limpeza quinzenal": "Por limpieza quincenal",
  "Por limpeza mensal": "Por limpieza mensual",
  "Por outra frequência": "Por otra frecuencia",
  "Instruções da chave / acesso": "Instrucciones de llave / acceso",
  "Código da porta, alarme, onde deixar a chave…": "Código de la puerta, alarma, dónde dejar la llave…",
  "Situação do orçamento": "Estado de la cotización",
  "Enviar para cadastro de cliente": "Enviar al registro de cliente",
  "Criar cliente já preenchido com os dados deste orçamento": "Crear un cliente precargado con los datos de esta cotización",
  "Salvar orçamento": "Guardar cotización",
  "Nome é obrigatório": "El nombre es obligatorio",
  "Orçamento atualizado": "Cotización actualizada",
  "Orçamento criado": "Cotización creada",
  "Preencha o nome antes de enviar para o cadastro de cliente": "Completa el nombre antes de enviar al registro de cliente",
  "Dados enviados para o cadastro de cliente": "Datos enviados al registro de cliente",
  "Crie e gerencie invoices/orçamentos para clientes.": "Crea y gestiona facturas/cotizaciones para clientes.",
  "Status": "Estado",
  "Ações": "Acciones",
  "Rejeitar": "Rechazar",
  "Reabrir": "Reabrir",
  "Baixar PDF": "Descargar PDF",
  "Criar cliente": "Crear cliente",
  "Marcar como aprovado": "Marcar como aprobado",
  "Marcar como rejeitado": "Marcar como rechazado",
  "Criar cliente com dados deste orçamento": "Crear cliente con los datos de esta cotización",
  "PDF gerado": "PDF generado",
  "Excluir orçamento de \"{name}\"?": "¿Eliminar la cotización de \"{name}\"?",
  "Orçamento excluído": "Cotización eliminada",
  "Status atualizado": "Estado actualizado",
  "Em aberto": "Abierta",
  "Casa única": "Casa unifamiliar",
  "Sobrado": "Casa adosada",
  "Apartamento": "Apartamento",
  "Cozinha": "Cocina",
  "Sala de família": "Sala familiar",
  "Sala de estar": "Sala de estar",
  "Sala de jantar": "Comedor",
  "Escadas": "Escaleras",
  "Sótão": "Ático",
  "Porão": "Sótano",
  "Garagem": "Garaje",
  "Lavanderia": "Lavandería",
  "Escritório": "Oficina / Estudio",
  "Sala de recreação": "Sala de recreación",
  "Corredor": "Pasillo",
  "Padrão": "Estándar",
  "Profunda": "Profunda",
  "Festa / Ocasião especial": "Fiesta / Ocasión especial",
  "Janelas": "Ventanas",
  "Mudança (entrada/saída)": "Mudanza (entrada/salida)",
  "Única vez": "Una vez",
  "2x por mês": "2x al mes",
  "Sazonal": "Por temporada",
  "Anual": "Anual",
  "8h – 11h": "8am – 11am",
  "11h – 16h": "11am – 4pm",
  "16h – 19h": "4pm – 7pm",
  "Limpeza de forno": "Limpieza de horno",
  "Geladeira": "Refrigerador",
  "Lavagem de paredes": "Lavado de paredes",
  "Persianas": "Persianas",
  "Luminárias": "Luminarias",
  "Encerar piso": "Encerar el piso",
  "Sim": "Sí",
  "Não": "No",
  "SMS (Texto)": "SMS (Texto)",
  "Sem link público": "Sin enlace público",
  "Cliente sem telefone cadastrado": "Cliente sin teléfono registrado",
  "Cliente sem e-mail cadastrado": "Cliente sin correo registrado",
  "Nenhum link disponível para este registro": "No hay enlace disponible para este registro",
  "Link copiado!": "¡Enlace copiado!",
  "Enviar": "Enviar",
  "João da Silva": "Juan Pérez",
  "123 Main St, Cidade, Estado 00000": "123 Main St, Ciudad, Estado 00000",
  "Nenhum orçamento ainda. Clique em \"Novo orçamento\" para começar.": "Aún no hay cotizaciones. Haz clic en \"Nueva cotización\" para comenzar.",

  // ── Equipments / Supplies (diálogos) ─────────────────────────────────────
  "+{qty} {unit} adicionados": "+{qty} {unit} agregados",
  "Ajustado para {qty} {unit}": "Ajustado a {qty} {unit}",
  "Ajuste": "Ajuste",
  "Ajuste de estoque": "Ajuste de stock",
  "Ajuste em {team}": "Ajuste en {team}",
  "Atual:": "Actual:",
  "Comprar": "Comprar",
  "Confirmar": "Confirmar",
  "Descartável": "Desechable",
  "Editar equipamento": "Editar equipo",
  "Editar item": "Editar artículo",
  "Em estoque": "En stock",
  "Em manutenção": "En mantenimiento",
  "Em uso": "En uso",
  "Entrada": "Entrada",
  "Entrada de estoque": "Entrada de stock",
  "Equipamento salvo": "Equipo guardado",
  "Equipe que Consumiu (opcional)": "Equipo que consumió (opcional)",
  "Estoque Inicial": "Stock inicial",
  "Estoque Mínimo": "Stock mínimo",
  "Estoque atual:": "Stock actual:",
  "Estoque correto": "Stock correcto",
  "Ex: 2 anos, 18 meses…": "Ej.: 2 años, 18 meses…",
  "Ex: Aspirador de pó, Vassoura…": "Ej.: Aspiradora, Escoba…",
  "Ex: Compra Walmart": "Ej.: Compra en Walmart",
  "Ex: Detergente, Esponja, Pano de microfibra…": "Ej.: Detergente, Esponja, Paño de microfibra…",
  "Ex: Home Depot, Amazon…": "Ej.: Home Depot, Amazon…",
  "Ex: Lysol, Clorox…": "Ej.: Lysol, Clorox…",
  "Ex: Recontagem mensal": "Ej.: Reconteo mensual",
  "Ex: Usado na limpeza Anna Smith": "Ej.: Usado en la limpieza de Anna Smith",
  "Histórico de movimentação": "Historial de movimientos",
  "Informe a quantidade": "Indica la cantidad",
  "Item salvo": "Artículo guardado",
  "Marca": "Marca",
  "Motivo / Observação": "Motivo / Nota",
  "Movimentação registrada": "Movimiento registrado",
  "Mínimo": "Mínimo",
  "Mínimo:": "Mínimo:",
  "Nenhum equipamento cadastrado.": "No hay equipos registrados.",
  "Nenhum item cadastrado.": "No hay artículos registrados.",
  "Nenhuma movimentação encontrada com esses filtros.": "No se encontraron movimientos con estos filtros.",
  "Nenhuma movimentação encontrada.": "No se encontraron movimientos.",
  "Nome do Equipamento": "Nombre del equipo",
  "Novo item de limpeza": "Nuevo artículo de limpieza",
  "Onde Foi Comprado": "Dónde se compró",
  "Produto": "Producto",
  "Quantidade ({unit})": "Cantidad ({unit})",
  "Quantidade Total": "Cantidad total",
  "Químico": "Químico",
  "Saída": "Salida",
  "Saída / consumo": "Salida / consumo",
  "Tempo Estimado de Uso": "Tiempo estimado de uso",
  "Todos os itens estão acima do estoque mínimo. Nenhuma reposição necessária.": "Todos los artículos están por encima del stock mínimo. No se necesita reposición.",
  "Total": "Total",
  "Unidade": "Unidad",
  "Valor da Compra (US$)": "Valor de compra (US$)",
  "distribuído": "distribuido",
  "item(ns) precisam de reposição. Sugestão calculada para repor até o dobro do estoque mínimo.": "artículo(s) necesitan reposición. Sugerencia calculada para reponer hasta el doble del stock mínimo.",
  "por": "por",
  "un, ml, kg…": "u, ml, kg…",
  "{qty} alocado à equipe {team}": "{qty} asignado al equipo {team}",
  "{qty} devolvido da equipe {team}": "{qty} devuelto del equipo {team}",
  "−{qty} {unit} consumido": "−{qty} {unit} consumido",
  "−{qty} {unit} consumido por {team}": "−{qty} {unit} consumido por {team}",
  "BAIXO": "BAJO",

  // ── Portal do Cliente ────────────────────────────────────────────────────
  "Portal Clean Manager USA": "Portal Clean Manager USA",
  "Portal do Cliente": "Portal del Cliente",
  "Acesse seu histórico, recibos e orçamentos.": "Accede a tu historial, recibos y cotizaciones.",
  "Não tem acesso? Solicite ao seu gestor para liberar o portal.": "¿No tienes acceso? Pide a tu gestor que habilite el portal.",
  "Login falhou": "Error al iniciar sesión",
  "Olá, {name}!": "¡Hola, {name}!",
  "Minha Agenda": "Mi Agenda",
  "Recibos": "Recibos",
  "Orçamentos": "Cotizaciones",
  "Idioma": "Idioma",

  // ── Estimate PDF ─────────────────────────────────────────────────────────
  "Formulário de orçamento": "Formulario de cotización",
  "Dados do orçamento": "Datos de la cotización",
  "Nº do orçamento": "N.º de cotización",
  "Validade": "Validez",
  "Tarifas propostas": "Tarifas propuestas",
  "Outra": "Otra",
  "Assinatura": "Firma",
  "gerado em": "generado el",

  // ── Backend error messages (HTTPException details) ───────────────────────
  "Algo deu errado. Tente novamente.": "Algo salió mal. Inténtalo de nuevo.",
  "Acesso negado": "Acceso denegado",
  "Acesso restrito": "Acceso restringido",
  "Apenas admin pode criar notas pessoais": "Solo los administradores pueden crear notas personales",
  "Apenas imagens": "Solo imágenes",
  "Arquivo maior que 10MB": "Archivo mayor a 10MB",
  "Arquivo não encontrado": "Archivo no encontrado",
  "Cada regra precisa ter uma data OU dias da semana.": "Cada regla debe tener una fecha O días de la semana.",
  "Cliente inválido": "Cliente inválido",
  "Cliente não encontrado": "Cliente no encontrado",
  "Cliente precisa ter e-mail cadastrado": "El cliente debe tener un correo registrado",
  "Cliente sem coordenadas GPS": "Cliente sin coordenadas GPS",
  "Colaborador não encontrado": "Colaborador no encontrado",
  "Colaborador sem dias de trabalho definidos": "Colaborador sin días de trabajo definidos",
  "Configure o webhook primeiro": "Configura el webhook primero",
  "Convite ainda não foi preenchido": "La invitación aún no fue completada",
  "Convite não encontrado": "Invitación no encontrada",
  "Convite não preenchido ou já tratado": "Invitación sin completar o ya gestionada",
  "Credenciais inválidas": "Credenciales inválidas",
  "Código inválido ou expirado": "Código inválido o expirado",
  "Data inválida": "Fecha inválida",
  "Data ou hora inválida": "Fecha u hora inválida",
  "E-mail já cadastrado": "Correo ya registrado",
  "E-mail já em uso por outro usuário": "Correo ya en uso por otro usuario",
  "E-mail já utilizado por outro colaborador": "Correo ya usado por otro colaborador",
  "E-mail obrigatório": "Correo obligatorio",
  "E-mail ou nome com padrão de conta de teste não é permitido.": "No se permite un correo o nombre con patrón de cuenta de prueba.",
  "Email obrigatório": "Correo obligatorio",
  "Emergent não retornou email": "Emergent no devolvió un correo",
  "Empresa não encontrada": "Empresa no encontrada",
  "Envie 'ids' com a lista de clientes a remover.": "Envía 'ids' con la lista de clientes a eliminar.",
  "Envie 'ids' com a lista de usuários a remover.": "Envía 'ids' con la lista de usuarios a eliminar.",
  "Equipamento em uso por alguma equipe": "Equipo en uso por algún equipo",
  "Equipamento inválido": "Equipo inválido",
  "Equipe inválida": "Equipo inválido",
  "Equipe não encontrada": "Equipo no encontrado",
  "Esta conta foi criada com Google. Use o botão 'Entrar com Google'.": "Esta cuenta fue creada con Google. Usa el botón 'Ingresar con Google'.",
  "Este link expirou": "Este enlace ha expirado",
  "Este é o único admin da empresa. Promova outro antes de alterar.": "Este es el único administrador de la empresa. Promueve a otro antes de cambiar.",
  "Falha ao postar no webhook do Teams": "Error al publicar en el webhook de Teams",
  "Falha ao validar sessão Google": "Error al validar la sesión de Google",
  "Formato esperado YYYY-MM-DD": "Formato esperado YYYY-MM-DD",
  "Galeria indisponível": "Galería no disponible",
  "Informe a senha atual": "Indica la contraseña actual",
  "Item não encontrado": "Artículo no encontrado",
  "Já existe um cargo com este nome": "Ya existe un cargo con este nombre",
  "Já existe um usuário com esse e-mail. Use outro.": "Ya existe un usuario con ese correo. Usa otro.",
  "Já existe usuário com esse e-mail": "Ya existe un usuario con ese correo",
  "Limpeza já encerrada": "Limpieza ya cerrada",
  "Limpeza não está em andamento": "La limpieza no está en progreso",
  "Link inválido": "Enlace inválido",
  "Nada para atualizar": "Nada para actualizar",
  "Nota não encontrada": "Nota no encontrada",
  "Não autenticado": "No autenticado",
  "Não autorizado": "No autorizado",
  "Não encontrado": "No encontrado",
  "Não foi possível geocodificar este endereço": "No se pudo geocodificar esta dirección",
  "Não é possível excluir um admin": "No se puede eliminar a un administrador",
  "Não é possível excluir um super-admin": "No se puede eliminar a un super-administrador",
  "Orçamento não encontrado": "Cotización no encontrada",
  "Pagamentos indisponíveis (key ausente)": "Pagos no disponibles (falta la clave)",
  "Permissão negada": "Permiso denegado",
  "Plano inválido": "Plan inválido",
  "Plano não encontrado": "Plan no encontrado",
  "Plano & Cobrança": "Plan y Facturación",
  "Materiais com a equipe": "Materiales del equipo",
  "Equipamentos sob responsabilidade da sua equipe (somente leitura).": "Equipos bajo responsabilidad de tu equipo (solo lectura).",
  "Nenhum equipamento atribuído à sua equipe.": "Ningún equipo asignado a tu equipo.",
  "Material de limpeza": "Material de limpieza",
  "Avise quando um material estiver acabando ou tiver acabado. O admin é notificado para comprar.": "Avisa cuando un material se esté acabando o se haya acabado. El admin recibe la notificación para comprar.",
  "Nenhum material cadastrado.": "Ningún material registrado.",
  "Acabando": "Acabándose",
  "Acabou": "Se acabó",
  "Cancelar aviso": "Cancelar aviso",
  "Avisado: material acabou": "Avisado: material agotado",
  "Avisado: material acabando": "Avisado: material acabándose",
  "Aviso cancelado": "Aviso cancelado",
  "Avisos dos colaboradores": "Avisos del equipo",
  "Materiais que os líderes avisaram que estão acabando ou acabaram. Marque como comprado após repor.": "Materiales que los líderes avisaron que están acabándose o agotados. Marca como comprado tras reponer.",
  "Marcar como comprado": "Marcar como comprado",
  "Marcado como comprado": "Marcado como comprado",
  "Comprado e estoque atualizado": "Comprado y stock actualizado",
  "Quantidade comprada (opcional)": "Cantidad comprada (opcional)",
  "Se informar, entra automaticamente no estoque. Deixe em branco para apenas marcar como comprado.": "Si la indicas, entra automáticamente al stock. Déjala vacía para solo marcar como comprado.",
  "A Receber": "Cuentas por Cobrar",
  "Cada casa finalizada vira um item. Junte os itens de um cliente em uma fatura única para uma só cobrança.": "Cada casa finalizada se convierte en un ítem. Junta los ítems de un cliente en una sola factura para un único cobro.",
  "Itens pendentes (total)": "Ítems pendientes (total)",
  "cliente(s)": "cliente(s)",
  "Faturas em aberto": "Facturas abiertas",
  "fatura(s)": "factura(s)",
  "Pendentes por cliente": "Pendientes por cliente",
  "Faturas": "Facturas",
  "Nenhum item pendente. Finalize casas para gerar itens de fatura.": "No hay ítems pendientes. Finaliza casas para generar ítems de factura.",
  "item(ns)": "ítem(s)",
  "desde": "desde",
  "Gerar fatura": "Generar factura",
  "Nenhuma fatura gerada ainda.": "Aún no se generaron facturas.",
  "Paga": "Pagada",
  "Fatura": "Factura",
  "Baixa em": "Saldada el",
  "Dar baixa": "Marcar como pagada",
  "Excluir fatura?": "¿Eliminar factura?",
  "Os itens voltarão para 'pendente' e poderão ser faturados novamente.": "Los ítems volverán a 'pendiente' y podrán facturarse nuevamente.",
  "Fatura excluída": "Factura eliminada",
  "Juntar tudo": "Juntar todo",
  "Escolher período": "Elegir período",
  "Nenhum item pendente neste período.": "No hay ítems pendientes en este período.",
  "Total da fatura": "Total de la factura",
  "Nenhum item no período selecionado": "No hay ítems en el período seleccionado",
  "Fatura #{n} gerada — {v}": "Factura #{n} generada — {v}",
  "Falha ao gerar fatura": "Error al generar la factura",
  "Baixa registrada": "Pago registrado",
  "Falha ao dar baixa": "Error al saldar",
  "Forma de pagamento": "Forma de pago",
  "Data do pagamento": "Fecha de pago",
  "Confirmar baixa": "Confirmar pago",
  "Portal desativado para este cliente": "Portal desactivado para este cliente",
  "Preço não pode ser negativo": "El precio no puede ser negativo",
  "Quantidade deve ser maior que zero": "La cantidad debe ser mayor que cero",
  "Quantidade entre 1 e 60": "Cantidad entre 1 y 60",
  "Refresh ausente": "Falta el token de actualización",
  "Sem permissão": "Sin permiso",
  "Senha atual incorreta": "Contraseña actual incorrecta",
  "Senha deve ter pelo menos 6 caracteres": "La contraseña debe tener al menos 6 caracteres",
  "Senha do admin incorreta": "Contraseña del administrador incorrecta",
  "Sessão Google inválida ou expirada": "Sesión de Google inválida o expirada",
  "Sessão expirada": "Sesión expirada",
  "Solicitação não encontrada": "Solicitud no encontrada",
  "Status inválido": "Estado inválido",
  "Storage indisponível": "Almacenamiento no disponible",
  "Só é possível reverter limpezas em andamento.": "Solo se pueden revertir limpiezas en progreso.",
  "Template não encontrado": "Plantilla no encontrada",
  "Tenant não encontrado": "Inquilino no encontrado",
  "Tipo inválido": "Tipo inválido",
  "Token inválido": "Token inválido",
  "Token inválido ou expirado": "Token inválido o expirado",
  "Transação não encontrada": "Transacción no encontrada",
  "Use o portal interno": "Usa el portal interno",
  "Usuário não encontrado": "Usuario no encontrado",
  "Você não faz parte da equipe deste job": "No formas parte del equipo de este trabajo",
  "Webhook inválido": "Webhook inválido",
  "days deve estar entre 1 e 365": "days debe estar entre 1 y 365",
  "entity_id é obrigatório": "entity_id es obligatorio",
  "mode deve ser 'manual' ou 'auto'": "mode debe ser 'manual' o 'auto'",
  "session_id obrigatório": "session_id obligatorio",
  "user_id é obrigatório": "user_id es obligatorio",

  // ── Portal — páginas internas ─────────────────────────────────────────────
  "Agendado": "Agendado",
  "Concluído": "Completado",
  "Cancelado": "Cancelado",
  "Pendente": "Pendiente",
  "Bem-vindo,": "Bienvenido,",
  "Aqui você acompanha sua agenda, recibos e orçamentos.": "Aquí puedes seguir tu agenda, recibos y cotizaciones.",
  "Próximos serviços": "Próximos servicios",
  "Serviços concluídos": "Servicios completados",
  "Total gasto": "Total gastado",
  "Total serviços": "Total de servicios",
  "Próximo serviço": "Próximo servicio",
  "Ver toda a agenda →": "Ver toda la agenda →",
  "Você não tem nenhum serviço agendado no momento.": "No tienes ningún servicio agendado por el momento.",
  "Nenhum serviço cadastrado ainda.": "Aún no hay servicios registrados.",
  "finalizado em": "finalizado el",
  "Você ainda não tem serviços concluídos.": "Aún no tienes servicios completados.",
  "serviços concluídos": "servicios completados",
  "Pago": "Pagado",
  "Nenhum orçamento vinculado ao seu e-mail.": "No hay cotizaciones vinculadas a tu correo.",
  "Selecione uma data preferida": "Selecciona una fecha preferida",
  "Solicitação enviada! Vamos te responder em breve.": "¡Solicitud enviada! Te responderemos pronto.",
  "Erro ao enviar solicitação": "Error al enviar la solicitud",
  "Solicitar Agendamento": "Solicitar agendamiento",
  "Escolha sua data preferida e envie a solicitação. Vamos confirmar em até 48h.": "Elige tu fecha preferida y envía la solicitud. Confirmaremos en un plazo de 48h.",
  "— sem preferência —": "— sin preferencia —",
  "Frequência desejada": "Frecuencia deseada",
  "— a definir —": "— por definir —",
  "Observações (opcional)": "Notas (opcional)",
  "Conte qualquer detalhe importante (cômodos extras, acesso, pets…)": "Cuéntanos cualquier detalle importante (habitaciones extra, acceso, mascotas…)",
  "Enviando…": "Enviando…",
  "Enviar solicitação": "Enviar solicitud",
  "Suas solicitações": "Tus solicitudes",
  "Você ainda não fez nenhuma solicitação.": "Aún no has hecho ninguna solicitud.",
  "Resposta:": "Respuesta:",
  "Recusado": "Rechazado",
  "Novo local de acesso": "Nuevo lugar de acceso",
};
